module.exports = __webpack_public_path__ + "img/person.fe38d58b.png";